import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AdminEmailSuggestion } from "../../emailNotifications.types";
import { requestGetAdminSuggestions } from "./getAdminSuggestions.request";

const useGetAdminSuggestions = (
  options?: QueryOptions<AdminEmailSuggestion[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["email-notifications", "admin-suggestions"],
    queryFn: requestGetAdminSuggestions,
    ...options
  });

  return { suggestions: data ?? [], ...rest };
};

export default useGetAdminSuggestions;
